import { Exercise } from "../../models/Exercise";
import {
  addTicketWithExerciseToBasket,
  addTicketWithSeatToBasket,
  clearBasket,
  clearSelectExercise,
  removeTicketWithExerciseFromBasket,
  removeTicketWithSeatFromBasket,
  selectExercise,
  selectExerciseBySeat,
  setActiveStep,
} from "./basketActions";
import { TicketBillLine } from "../../models/TicketBillLine";
import getId from "../../utils/getId";

export interface BasketState {
  exerciseSelect: Exercise[];
  basket: TicketBillLine[];
  activeStep: number;
}

const initialBasket: BasketState = {
  exerciseSelect: [],
  basket: [],
  activeStep: 0,
};

const isBasket = (basket: TicketBillLine[], ticket: TicketBillLine) => {
  return basket.some((item) => item.tempId === ticket.tempId);
};

const isSelectExercise = (exerciseList: Exercise[], exercise: Exercise) => {
  return exerciseList.some((item) => getId(item) === getId(exercise));
};

export default function basketReducer(basket = initialBasket, action: any) {
  switch (action.type) {
    case selectExercise.toString():
      return {
        ...basket,
        exerciseSelect: isSelectExercise(basket.exerciseSelect, action.payload)
          ? basket.exerciseSelect.filter((item) => getId(item) !== getId(action.payload))
          : [action.payload, ...basket.exerciseSelect],
      };
    case clearSelectExercise.toString():
      return {
        ...basket,
        exerciseSelect: [],
      };
    case addTicketWithExerciseToBasket.toString():
      return {
        ...basket,
        basket: isBasket(basket.basket, action.payload)
          ? basket.basket.map((item: TicketBillLine) =>
              item.tempId === action.payload.tempId ? { ...item, quantity: item.quantity + 1 } : item
            )
          : [action.payload, ...basket.basket],
      };
    case removeTicketWithExerciseFromBasket.toString():
      return {
        ...basket,
        basket:
          isBasket(basket.basket, action.payload) && action.payload.quantity > 1
            ? basket.basket.map((item: TicketBillLine) =>
                item.tempId === action.payload.tempId ? { ...item, quantity: item.quantity - 1 } : item
              )
            : basket.basket.filter((item) => item.tempId !== action.payload.tempId),
      };
    case clearBasket.toString():
      return initialBasket;
    case selectExerciseBySeat.toString():
      return {
        ...basket,
        exerciseSelect: [action.payload]
      };
    case addTicketWithSeatToBasket.toString():
      return {
        ...basket,
        basket: isBasket(basket.basket, action.payload)
          ? basket.basket.filter((item) => item.tempId !== action.payload.tempId)
          : [action.payload, ...basket.basket],
      };
    case removeTicketWithSeatFromBasket.toString():
      return {
        ...basket,
        basket: basket.basket.filter((item) => item.tempId !== action.payload.tempId),
      };
    case setActiveStep.toString():
      return {
        ...basket,
        activeStep: action.payload,
      };
    default:
      return basket;
  }
}
